import React from "react";
import { IconButton, Typography } from "@material-ui/core";
import { IoIosCloseCircleOutline } from "react-icons/io";

export default function Chip({
  label,
  onDelete,
  isValid,
}) {
  const bgColor = (isValid === undefined || isValid === null)
    ? "#e5e7eb"
    : isValid
      ? "#e5e7eb"
      : "#D22B2B";

  const color = (isValid === undefined || isValid === null)
    ? "#4b5563"
    : "#424242";

  return (
    <div
      style={{
        backgroundColor: bgColor,
        borderRadius: "20px",
        padding: "2px 8px 2px 11px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Typography
        style={{
          maxWidth: "430px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          fontSize: "14px",
          color: color,
        }}
      >
        {label}
      </Typography>
      <IconButton style={{ padding: 2, fontSize: 22, color: color }} onClick={onDelete}>
        <IoIosCloseCircleOutline />
      </IconButton>
    </div>
  );
}
